



















import { PropType } from 'vue';
import { IAiStream } from '../types';
import { fmtTime } from '../utils';
import StreamRow from './StreamRow.vue';

export default {
  name: 'StreamClusterDialog',
  components: { StreamRow },
  props: {
    value: { type: Boolean, default: false },
    items: {
      type: Array as PropType<IAiStream[]>,
      default: (): IAiStream[] => []
    },
    colorMap: {
      type: Object as PropType<Record<string, string>>,
      default: (): Record<string, string> => ({})
    },
    timeZone: { type: String, default: 'UTC' }
  },
  computed: {
    timeLabel(): string {
      if (!this.items.length) return '';
      const start = this.items.reduce(
        (m: string, s: IAiStream) =>
          (s.startTime || '') < m ? s.startTime || '' : m,
        this.items[0].startTime || ''
      );
      const end = this.items.reduce(
        (m: string, s: IAiStream) =>
          (s.endTime || '') > m ? s.endTime || '' : m,
        this.items[0].endTime || ''
      );
      return `${fmtTime(start)}-${fmtTime(end)}`;
    }
  },
  methods: {
    onSelect(stream: IAiStream): void {
      this.$emit('select', stream);
    }
  }
};
